import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Typography from "@material-ui/core/Typography";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import type { RankFilter } from "../data/types";

export interface RankFilterBarProps {
  rankFilter: RankFilter;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const RankFilterBar: React.FC<RankFilterBarProps> = ({
  rankFilter,
  onChange,
}) => {
  const classes = useStyles();
  const translate = useTranslation().t;

  return (
    <div className={classes.filterContainer}>
      <Typography variant="body2" className={classes.filterLabel}>
        {translate("FILTER")}:
      </Typography>
      <RadioGroup
        row
        value={rankFilter}
        onChange={onChange}
        className={classes.radioGroup}
      >
        <FormControlLabel
          value="TOP_RANKED"
          control={<Radio size="small" className={classes.radioPrimary} />}
          label={translate("TOP_RANKED")}
          labelPlacement="end"
          className={classes.radioLabel}
        />
        <FormControlLabel
          value="MY_RANK"
          control={<Radio size="small" className={classes.radioPrimary} />}
          label={translate("MY_RANK")}
          labelPlacement="end"
          className={classes.radioLabel}
        />
      </RadioGroup>
    </div>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    filterContainer: {
      marginTop: 8,
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 8,
      height: 28,
    },
    filterLabel: {
      marginRight: 4,
      fontWeight: 600,
    },
    radioPrimary: {
      color: "#6A46E5",
      "&.Mui-checked": {
        color: "#6A46E5",
      },
    },
    radioLabel: {
      "& .MuiFormControlLabel-label": {
        fontSize: 14,
      },
    },
    radioGroup: {
      margin: 0,
    },
  })
);

export default RankFilterBar;
